export default "__VITE_ASSET__B_$osXUO__"